:host {
  display: flex;
  flex-direction: column;

  /**
   * @prop --viewer-measurement-details-x-color:
   * The color of the `X` label in measurements.
   * Defaults to red.
   */
  --viewer-measurement-details-x-color: red;

  /**
   * @prop --viewer-measurement-details-y-color:
   * The color of the `X` label in measurements.
   * Defaults to var(--green-500).
   */
  --viewer-measurement-details-y-color: var(--green-500);

  /**
   * @prop --viewer-measurement-details-z-color:
   * The color of the `X` label in measurements.
   * Defaults to blue.
   */
  --viewer-measurement-details-z-color: blue;
}

.measurement-details-entry {
  display: flex;
  align-items: center;
}

.measurement-details-entry-label {
  user-select: none;
  padding-right: 0.25rem;
}

.measurement-details-entry-label.x {
  color: var(--viewer-measurement-details-x-color);
}

.measurement-details-entry-label.y {
  color: var(--viewer-measurement-details-y-color);
}

.measurement-details-entry-label.z {
  color: var(--viewer-measurement-details-z-color);
}
